import { useGetLatestQuestionItemAnalysisReportCreatedAtQuery } from '@report/graphql';
import { APP_PERMISSIONS } from '@report/permission';
import { ItemAnalysisProvider, ItemAnalysisSection } from '@report/qbank-item-analysis';
import { useNavigate } from '@report/router';
import { Flex, PageHeader, Text, Button, ArrowBackRoundedIcon, Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { formatDateTime } from '@shared/utils';

export default function ExamManagementItemAnalysisPage() {
  const navigate = useNavigate();
  const { data } = useGetLatestQuestionItemAnalysisReportCreatedAtQuery();
  const latestCreatedAt = formatDateTime(
    data?.reportGetLatestQuestionItemAnalysisReportCreatedAt.latestCreatedAt,
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_REPORT.VIEW}>
      <ItemAnalysisProvider>
        <PageHeader
          title='รายงานวิเคราะห์คุณภาพข้อสอบ: แบบรายข้อ'
          subtitleSection={
            <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
              <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
                ประเมินคุณภาพข้อสอบรายข้อด้วยค่า P และ B-Index
              </Text>
              <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
                อัปเดตข้อมูลล่าสุด: {latestCreatedAt}
              </Text>
            </Flex>
          }
          linkAdornment={
            <Button
              variant='text'
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate('/reports')}
              sx={{
                p: (theme) => theme.spacing(0),
                minWidth: 'auto',
                height: 'auto',
              }}
            >
              Back
            </Button>
          }
        />
        <Box sx={{ p: (theme) => theme.spacing(6) }}>
          <ItemAnalysisSection />
        </Box>
      </ItemAnalysisProvider>
    </PermissionGuard>
  );
}
